import React, { Component } from "react"
import { Container, Segment, Image } from "semantic-ui-react"
import { COLORS } from '../utilities/colours'
import ConsumerMLBB from './consumers/ConsumerMLBB'

class ConsumerLandingPage extends Component {
    state = { innerWidth: null }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this))
        this.setState({ innerWidth: window.innerWidth })
    }

    resize() {
        this.setState({ innerWidth: window.innerWidth })
    }

    render() {
        //`linear-gradient(135deg, ${COLORS.SECONDARY_GOLD}, ${COLORS.PRIMARY_GOLD})`
        const widthHeight = window.innerWidth < 690 ? '18%' : '13%'
        var top = window.innerWidth < 690 ? -30 : 10
        if (window.innerWidth < 500) top = -40
        return (
            <div style={{ background: COLORS.BACKGROUND, minHeight: "100vh", color: COLORS.TEXT_WHITE }}>
                <Container fluid style={{ padding: "20px 0" }}>
                <Image style={{ position: "absolute", top: top, left: 20, margin: 0, padding: 0, zIndex: 1000, width: widthHeight, height: widthHeight, objectFit: 'contain' }} src='/egc-logo-transparent.png'/>
                    <ConsumerMLBB/>
                    <br/><br/><br/><br/><br/><br/><br/><br/>
                    <Segment textAlign="center" style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: COLORS.BACKGROUND, padding: 10 }}>
                        <p style={{ color: COLORS.PRIMARY_GOLD, fontSize: '0.9em' }}>
                            © 2025 Emperor Gaming Credits | Contact us on{" "}
                            <a href="https://t.me/EmperorGameCredits" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.PRIMARY_GOLD }}>
                                <u>Telegram</u>
                            </a>{" "}
                            or{" "}
                            <a href="https://wa.me/6592225494" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.PRIMARY_GOLD }}>
                                <u>WhatsApp</u>
                            </a>
                        </p>
                    </Segment>
                </Container>
            </div>
        )
    }
}

export default ConsumerLandingPage